import "./style/index.scss";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Divider, Form, Input, Row, Space } from "antd";
import { useEffect } from "react";
import { setModalCadastrarCentroCusto } from "../../../../redux/slices/centroCusto/centroCustoSlice";
import { atualizarCentroCusto, cadastrarCentroCusto } from "../../../../services/centroCustoService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import SelectTree from "../../../../components/inputs/selectTree";

const CadastroEdicaoCentroCusto = () => {
  //estados globais
  const centroCustoState = useAppSelector((state) => state.centroCusto);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<any>();

  const editar = Object.values(centroCustoState.entity).length !== 0;

  useEffect(() => {
    if (editar) {
      centroCustoState.entity.receita && centroCustoState.entity.despesa
        ? form.setFieldValue("tipo", ["R", "D"])
        : centroCustoState.entity.receita
        ? form.setFieldValue("tipo", ["R"])
        : form.setFieldValue("tipo", ["D"]);
      form.setFieldsValue({ ...centroCustoState.entity });
    } else {
      form.setFieldsValue({ ativo: true });
    }
  }, [centroCustoState.entity]);

  const onValueForm = (value: any) => {
    if (value.idPai === 0) {
      form.setFieldValue("idPai", null);
    }
  };

  const submit = (value: any) => {
    const objRecDesp = value.tipo.length === 1 ? (value.tipo[0] === "R" ? { despesa: false, receita: true } : { receita: false, despesa: true }) : { receita: true, despesa: true };

    delete value.tipo;

    const submitCentroCusto = { ...value, ...objRecDesp };

    if (editar) {
      submitCentroCusto.id = centroCustoState.entity.id;
      dispatch(atualizarCentroCusto({ value: submitCentroCusto, busca: centroCustoState.busca }));
    } else {
      dispatch(cadastrarCentroCusto({ value: submitCentroCusto, busca: centroCustoState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarCentroCusto(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical" onValuesChange={onValueForm}>
      <Row gutter={12}>
        <Col span={10}>
          <Form.Item label="Item Superior" name="idPai">
            <SelectTree loading={centroCustoState.loading} list={centroCustoState.list} centroCusto={true} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="tipo"
            label="Tipo"
            rules={[
              {
                required: true,
                message: "Deve ser selecionado ao menos um",
              },
            ]}
          >
            <Checkbox.Group>
              <Checkbox value="R">Receita</Checkbox>
              <Checkbox value="D">Despesa</Checkbox>
            </Checkbox.Group>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="ativo" label="Ativo" valuePropName="checked">
            <Checkbox name="ativo">Ativo</Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={8}>
          <Form.Item
            label="Abreviação"
            name="abreviacao"
            rules={[
              {
                required: true,
                message: "Digite a abreviação do centro de custo",
              },
            ]}
          >
            <Input type="text" placeholder="Digite a abreviação" />
          </Form.Item>
        </Col>
        <Col span={15}>
          <Form.Item
            label="Denominação"
            name="denominacao"
            rules={[
              {
                required: true,
                message: "Digite a denominação",
              },
            ]}
          >
            <Input type="text" placeholder="Digite a denominação" />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroEdicaoCentroCusto;
